<template>
  <BaseModal :title="isViewPlayList && playlists.length > 1 ? 'Xem danh sách phát: ' + title : 'Xem tệp tin: ' + title"
    :show.sync="isShow" :closeOnBackdrop="false" :size="isViewPlayList ? 'lg' : ''">
    <template v-slot:body-wrapper>
      <div class="modal-body content-fade-in">
        <template v-if="isViewPlayList">
          <div class="simple-audio-player" id="simp"
            data-config='{"shide_top":false,"shide_btm":false,"auto_load":false}'>
            <audio id="audio" preload ref="audio">
              <source src="" type="audio/mpeg">
            </audio>
            <div class="simp-display">
              <div class="simp-album w-full flex-wrap">
                <div class="simp-cover">
                  <i v-if="!isPlaying" class="fa fa-music fa-3x"></i>
                  <div v-else class="effect-wave" style="background-image: url('../../static/img/icon-playing.gif')">
                  </div>
                  <!--                  <div v-else class="effect-wave" style="background-image: url('../static/img/playing_v2.gif')"></div>-->
                </div>
                <div class="simp-info">
                  <div class="simp-title">{{ playlists.length > 0 ? playlists[index].title : '' }}</div>
                  <div class="simp-artist">{{ playlists.length > 0 ? playlists[index].fileTypeName : '' }}</div>
                </div>
              </div>
            </div>
            <div class="simp-controls flex-wrap flex-align">
              <div class="simp-plauseward flex flex-align" ref="plauseward">
                <button type="button" class="simp-prev fa fa-backward" disabled></button>
                <button type="button" class="simp-plause fa fa-play" disabled ref="simp-plause"></button>
                <button type="button" class="simp-next fa fa-forward" disabled></button>
              </div>
              <div class="simp-tracker simp-load">
                <input class="simp-progress" type="range" min="0" max="100" v-model="progress"
                  :data-value="clickProgress" disabled ref="progress" />
                <div class="simp-buffer"></div>
              </div>
              <div class="simp-time flex flex-align"><span class="start-time">{{ startTime }}</span><span
                  class="simp-slash">&#160;/&#160;</span><span class="end-time">{{ endTime }}</span></div>
              <div class="simp-volume flex flex-align">
                <button type="button" class="simp-mute fa" :class="isMuted ? 'fa-volume-off' : 'fa-volume-up'"
                  @click="mutedAudio"></button>
                <input class="simp-v-slider" type="range" min="0" max="100" v-model="volume" ref="volume" />
              </div>
            </div>
            <div class="simp-playlist">
              <ul v-for="(file, index) in playlists">
                <li @click.prevent="clickRowPlayList(index)">
                  <span class="simp-source" :data-src="file.url">{{ file.title }}</span>
                  <!--                  <span class="simp-desc">{{ file.fileTypeName }}</span>-->
                </li>
              </ul>
            </div>
          </div>
        </template>
        <template>
          <!--          <audio v-show="!hlsPreview" :src="url" controls autoplay style="width: 100%" ref="previewAudio"></audio>-->
          <audio v-show="!isViewPlayList" controls autoplay style="width: 100%" ref="previewChannelDigitalHLS"></audio>
        </template>
      </div>
      <BaseFormLoading :loading="loading.value"></BaseFormLoading>
    </template>
    <template v-slot:footer>
      <div slot="footer">
        <button type="button" class="btn btn-secondary" @click="closePreviewAudio()"><i class="fa fa-close"></i> Đóng
        </button>&nbsp;
      </div>
    </template>
  </BaseModal>
</template>
<script>
import BaseFormLoading from "@/views/base/BaseFormLoading";
import BaseModal from "@/views/base/BaseModal";

export default {
  components: { BaseModal, BaseFormLoading },
  props: {
    title: String,
    url: String,
    playListId: Number,
    fileTypeName: String
  },
  data() {
    return {
      loading: { value: false },
      isShow: true,
      isViewPlayList: null,
      hlsPreview: '',
      wavesurfer: '',
      startTime: '00:00',
      endTime: '00:00',
      isLoaded: false,
      isPlaying: false,
      isStream: false,
      index: 0,
      autoLoad: false,
      simp_isNext: false,
      progress: 100,
      clickProgress: 0,
      volume: 100,
      isMuted: false,
      playlists: []
    };
  },
  methods: {
    async previewFile() {
      let that = this;
      if (this.playListId && this.playListId != '' && this.playListId != null) {
        this.loadPlayList();
      } else {
        if (this.url.includes(".m3u8") || this.url.includes(".mpd")) {
          var audio = this.$refs.previewChannelDigitalHLS;
          var urlDetail = this.url.split(",")
          for (var i = 0; i < urlDetail.length; i++) {
            if (urlDetail[i].includes(".mpd")) {
            } else if (urlDetail[i].includes(".m3u8")) {
              var res = await that.loadViewHLS(urlDetail[i], audio);
              if (res != true) {
                audio.play();
                that.hlsPreview = res;
                setTimeout(() => {
                  that.loading.value = false;
                }, 500)
                break;
              }
            } else {
              this.showErrorMsg({ message: 'Không thể nghe thử' })
            }
          }
          this.isViewPlayList = false;
          this.isShow = true;
        } else {
          this.playlists.push({
            url: this.url,
            title: this.title,
            fileTypeName: this.fileTypeName
          })
          setTimeout(() => {
            that.startPlayPlist();
          }, 100)
        }
        // if (this.playlists.length > 0) {
        //   this.isViewPlayList = true;
        // } else {
        //   this.isViewPlayList = false;
        // }
        // this.isShow = true;
      }
    },
    async loadViewHLS(url, audio) {
      this.isShow = true;
      this.loading.value = true;
      return new Promise((resolve) => {
        if (Hls.isSupported()) {
          this.loading.value = true;
          var hls = new Hls();
          hls.loadSource(url);
          hls.attachMedia(audio);
          hls.on(Hls.Events.ERROR, function (event, data) {
            var errorFatal = data.fatal;
            resolve(errorFatal);
          });
          hls.on(Hls.Events.MANIFEST_PARSED, function (data) {
            resolve(hls)
          });
        } else if (audio.canPlayType('application/vnd.apple.mpegurl')) {
          audio.src = url;
          resolve(url);
        } else {
          this.showErrorMsg({ message: 'Không thể nghe thử' })
        }
      })
    },
    closePreviewAudio() {
      if (this.playListId) {
        // this.wavesurfer.stop();
        this.$refs.audio.pause();
      } else {
        if (this.hlsPreview && !this.hlsPreview) {
          this.$refs.previewAudio.pause();
        } else {
          if (this.hlsPreview && Hls.isSupported()) {
            this.hlsPreview.destroy();
          } else {
            this.$refs.previewChannelDigitalHLS.pause();
          }
          this.hlsPreview = '';
        }
      }
      this.isShow = false;
      this.$emit("close-modal", false);
    },
    loadPlayList() {
      let that = this
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/play-list/find-by-id",
        dataSubmit() {
          return {
            id: that.playListId
          }
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.playlists = response.data.data.lstDetail;
            setTimeout(() => {
              that.startPlayPlist();
            }, 100)
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },

    clickRowPlayList(index) {
      if (this.playlists.length <= 1) {
        return;
      }
      this.index = index;
      this.$refs.audio.removeEventListener('timeupdate', this.simp_initTime);
      this.simp_changeAudio(this.playlists[index].url);
    },

    mutedAudio() {
      if (!this.isMuted) {
        this.$refs.audio.muted = true;
      } else {
        this.$refs.audio.muted = false;
      }
      this.isMuted = !this.isMuted;
    },

    startPlayPlist() {
      let that = this;
      var simp_audio = this.$refs.audio;
      var simp_volume = this.$refs.volume;
      this.isViewPlayList = true;
      this.isShow = true;
      that.simp_changeAudio(document.querySelector('.simp-source'));
      this.$refs.plauseward.addEventListener('click', function (e) {
        var eles = e.target.classList;
        if (eles.contains('simp-plause')) {
          if (simp_audio.paused) {
            if (!that.isLoaded) {
              that.simp_loadAudio(that.playlists[that.index].url);
            }
            simp_audio.play();
            that.isPlaying = true;
            eles.remove('fa-play');
            eles.add('fa-pause');
          } else {
            simp_audio.pause();
            that.isPlaying = false;
            eles.remove('fa-pause');
            eles.add('fa-play');
          }
        } else {
          if (eles.contains('simp-prev') && that.index != 0) {
            that.index = that.index - 1;
            e.target.disabled = that.index == 0 ? true : false;
          } else if (eles.contains('simp-next') && that.index != that.playlists.length - 1) {
            that.index = that.index + 1;
            e.target.disabled = that.index == that.playlists.length - 1 ? true : false;
          }
          simp_audio.removeEventListener('timeupdate', that.simp_initTime);
          that.simp_changeAudio(that.playlists[that.index].url);
        }
      });

      // Audio volume
      simp_volume.addEventListener('click', function (e) {
        if (that.volume == 0) {
          that.isMuted = true;
        } else {
          that.isMuted = false;
          that.$refs.audio.muted = false;
          document.querySelector('.simp-mute').classList.remove('fa-volume-off');
          document.querySelector('.simp-mute').classList.add('fa-volume-up');
        }
        simp_audio.volume = parseFloat(that.volume / 100);
      });

    },

    addEventListener_multi(element, eventNames, handler) {
      var events = eventNames.split(' ');
      events.forEach(e => element.addEventListener(e, handler, false));
    },

    getRelativePos(elm) {
      var pPos = elm.parentNode.getBoundingClientRect(); // parent pos
      var cPos = elm.getBoundingClientRect(); // target pos
      var pos = {};
      pos.top = cPos.top - pPos.top + elm.parentNode.scrollTop,
        pos.right = cPos.right - pPos.right,
        pos.bottom = cPos.bottom - pPos.bottom,
        pos.left = cPos.left - pPos.left;

      return pos;
    },
    formatTime(val) {
      var h = 0, m = 0, s;
      val = parseInt(val, 10);

      if (val > 60 * 60) {
        h = Math.floor(val / (60 * 60));
        val -= h * 60 * 60;
      }
      if (val > 60) {
        m = Math.floor(val / 60);
        val -= m * 60;
      }
      s = val;
      // Kiểm tra và xử lý khi giây vượt quá 59
      if (s >= 60) {
        m += Math.floor(s / 60);
        s %= 60;
      }
      var formattedTime = '';
      if (h > 0) {
        formattedTime += String(h).padStart(2, '0') + ':';
      }
      formattedTime += String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      return formattedTime;
    },

    simp_loadAudio(url) {
      var simp_audio = this.$refs.audio;
      var simpPause = this.$refs["simp-plause"];
      var progress = this.$refs.progress;
      progress.parentNode.classList.add('simp-loading');
      simpPause.setAttribute("disabled", true);
      simp_audio.querySelector('source').src = url;
      simp_audio.load();

      simp_audio.volume = parseFloat(this.volume / 100);
      simp_audio.addEventListener('canplaythrough', this.simp_initAudio);

      // if audio fails to load, only IE/Edge 9.0 or above
      simp_audio.addEventListener('error', function () {
        alert('Please reload the page.');
      });
    },

    simp_changeAudio(url) {
      var progress = this.$refs.progress;
      this.isLoaded = false;
      document.querySelector('.simp-prev').disabled = this.index == 0 ? true : false;
      document.querySelector('.simp-plause').disabled = this.autoLoad ? true : false;
      document.querySelector('.simp-next').disabled = this.index == this.playlists.length - 1 ? true : false;
      // progress.parentNode.classList.add('simp-load');
      // progress.disabled = true;
      progress.parentNode.classList.add('simp-load');
      progress.setAttribute("disabled", true);
      this.progress = 0;
      this.startTime = '00:00';
      this.endTime = '00:00';

      // playlist, audio is running
      var ap_simp = document.querySelector('#simp');
      var simp_playlist = ap_simp.querySelector('.simp-playlist');
      var simp_source = simp_playlist.querySelectorAll('li');
      var simp_a_url = simp_playlist.querySelectorAll('[data-src]');

      for (var i = 0; i < simp_a_url.length; i++) {
        simp_a_url[i].parentNode.classList.remove('simp-active');
        if (simp_a_url[i] == url || simp_a_url[i].dataset.src == url) {
          this.index = i;
          simp_a_url[i].parentNode.classList.add('simp-active');
        }
      }

      // scrolling to element inside element
      var simp_active = this.getRelativePos(simp_source[this.index]);
      simp_source[this.index].parentNode.scrollTop = simp_active.top;

      if (this.autoLoad || this.isPlaying) {
        this.simp_loadAudio(url);
      }

      if (this.isPlaying) {
        var pause = this.$refs["simp-plause"];
        pause.classList.remove('fa-play');
        pause.classList.add('fa-pause');
      }
    },

    simp_initAudio() {
      let that = this;
      // if readyState more than 2, audio file has loaded
      var simp_audio = this.$refs.audio;
      var pause = this.$refs["simp-plause"];
      var progress = this.$refs.progress;
      this.isLoaded = simp_audio.readyState == 4 ? true : false;
      this.isStream = simp_audio.duration == 'Infinity' ? true : false;
      pause.removeAttribute("disabled");
      // progress.setAttribute("disabled", this.isStream ? true : false);
      progress.removeAttribute("disabled");
      if (!this.isStream) {
        progress.parentNode.classList.remove('simp-load', 'simp-loading');
        this.endTime = this.formatTime(simp_audio.duration);
      }
      simp_audio.addEventListener('timeupdate', this.simp_initTime);
      if (this.isLoaded && this.isPlaying) {
        simp_audio.play();
      }

      // progress bar click event
      this.addEventListener_multi(progress, 'touchstart mousedown', function (e) {
        if (this.isStream) {
          e.stopPropagation();
          return false;
        }
        if (simp_audio.readyState == 4) {
          simp_audio.removeEventListener('timeupdate', that.simp_initTime);
          simp_audio.pause();
        }
      });

      this.addEventListener_multi(progress, 'touchend mouseup', function (e) {
        if (this.isStream) {
          e.stopPropagation();
          return false;
        }
        if (simp_audio.readyState == 4) {
          simp_audio.currentTime = that.progress * simp_audio.duration / 100;
          simp_audio.addEventListener('timeupdate', that.simp_initTime);
          if (that.isPlaying) {
            simp_audio.play()
          }
        }
      });
    },

    simp_initTime() {
      var simp_audio = this.$refs.audio;
      var pause = this.$refs["simp-plause"];
      if (simp_audio) {
        this.startTime = this.formatTime(simp_audio.currentTime);
        if (!this.isStream) {
          this.endTime = this.formatTime(simp_audio.duration);
          this.progress = simp_audio.currentTime / simp_audio.duration * 100; //progress bar
        }
      }

      // ended of the audio
      if (simp_audio && simp_audio.currentTime == simp_audio.duration) {
        pause.classList.remove('fa-pause');
        pause.classList.add('fa-play');
        simp_audio.removeEventListener('timeupdate', this.simp_initTime);

        if (this.simp_isNext) { //auto load next audio
          var elem;
          this.index++;
          if (this.index == this.playlists.length) { //repeat all audio
            this.index = 0;
            elem = this.playlists[0].url;
          } else {
            elem = this.playlists[this.index].url;
          }
          this.simp_changeAudio(elem);
        } else {
          this.isPlaying = false;
        }
      }
    }

  },
  created() {
  },
  mounted() {
    if (this.url && (this.url.includes(".m3u8") || this.url.includes(".mpd"))) {
      this.isViewPlayList = false;
    } else {
      this.isViewPlayList = true;
    }
    this.previewFile();
  },
  computed: {},
  watch: {
    isShow(value) {
      if (!value) {
        this.closePreviewAudio();
      }
    }
  }
};
</script>
<style scoped>
input,
button {
  outline: none;
}

a,
a:hover,
a:visited {
  color: #ddd;
  text-decoration: none;
}

.flex {
  display: -webkit-flex;
  display: flex;
}

.flex-wrap {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}

.flex-align {
  -webkit-align-items: center;
  align-items: center;
}

.w-full {
  width: 100%;
}

#simp button,
#simp input,
#simp img {
  border: 0;
}

#simp {
  /*max-width: 600px;*/
  font-size: 14px;
  font-family: "Segoe UI", Tahoma, sans-serif;
  text-align: initial;
  line-height: initial;
  background: #17212b;
  color: #ddd;
  margin: 0 auto;
  border-radius: 6px;
  overflow: hidden;
}

#simp .simp-album {
  padding: 20px 25px 5px;
}

#simp .simp-album .simp-cover {
  margin-right: 20px;
}

#simp .simp-album .simp-cover img {
  max-width: 80px;
  width: 100%;
  margin: 0;
  padding: 0;
  display: block;
}

#simp .simp-album .simp-title {
  font-size: 120%;
  font-weight: bold;
}

#simp .simp-album .simp-artist {
  font-size: 90%;
  color: #6c7883;
}

#simp .simp-controls {
  padding: 15px;
}

#simp .simp-controls button {
  font-size: 130%;
  width: 32px;
  height: 32px;
  background: none;
  color: #ddd;
  padding: 7px;
  cursor: pointer;
  border: 0;
  border-radius: 3px;
}

#simp .simp-controls button[disabled] {
  color: #636469;
  cursor: initial;
}

#simp .simp-controls button:not([disabled]):hover {
  background: #4082bc;
  color: #fff;
}

#simp .simp-controls .simp-prev,
#simp .simp-controls .simp-next {
  font-size: 100%;
}

#simp .simp-controls .simp-tracker,
#simp .simp-controls .simp-volume {
  flex: 1;
  margin-left: 10px;
  position: relative;
}

#simp .simp-controls .simp-buffer {
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  height: 5px;
  margin-top: -2.5px;
  border-radius: 100px;
}

#simp .simp-controls .simp-loading .simp-buffer {
  -webkit-animation: audio-progress 1s linear infinite;
  animation: audio-progress 1s linear infinite;
  background-image: linear-gradient(-45deg, #000 25%, transparent 25%, transparent 50%, #000 50%, #000 75%, transparent 75%, transparent);
  background-repeat: repeat-x;
  background-size: 25px 25px;
  color: transparent;
}

#simp .simp-controls .simp-time,
#simp .simp-controls .simp-others {
  margin-left: 10px;
}

#simp .simp-controls .simp-volume {
  max-width: 110px;
}

#simp .simp-controls .simp-volume .simp-mute {
  margin-right: 5px;
}

#simp .simp-controls .simp-others .simp-active {
  background: #242f3d;
}

#simp .simp-controls .simp-others .simp-shide button {
  font-size: 100%;
  padding: 0;
  width: 24px;
  height: 14px;
  display: block;
}

#simp .simp-controls input[type=range] {
  -webkit-appearance: none;
  background: transparent;
  height: 19px;
  margin: 0;
  width: 100%;
  display: block;
  position: relative;
  z-index: 2;
  cursor: pointer;
}

#simp .simp-controls input[type=range]::-webkit-slider-runnable-track {
  background: rgba(183, 197, 205, .66);
  height: 5px;
  border-radius: 2.5px;
  transition: box-shadow .3s ease;
  position: relative;
}

#simp .simp-controls input[type=range]::-moz-range-track {
  background: rgba(183, 197, 205, .66);
  height: 5px;
  border-radius: 2.5px;
  transition: box-shadow .3s ease;
  position: relative;
}

#simp .simp-controls .simp-load .simp-progress::-webkit-slider-runnable-track {
  background: #2f3841;
}

#simp .simp-controls .simp-load .simp-progress::-moz-range-track {
  background: #2f3841;
}

#simp .simp-controls .simp-loading .simp-progress::-webkit-slider-runnable-track {
  background: rgba(255, 255, 255, .25);
}

#simp .simp-controls .simp-loading .simp-progress::-moz-range-track {
  background: rgba(255, 255, 255, .25);
}

#simp .simp-controls input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
  background: #fff;
  height: 13px;
  width: 13px;
  margin-top: -4px;
  cursor: pointer;
  border-radius: 50%;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .15), 0 0 0 1px rgba(47, 52, 61, .2);
}

#simp .simp-controls input[type=range]::-moz-range-thumb {
  -webkit-appearance: none;
  background: #fff;
  height: 13px;
  width: 13px;
  cursor: pointer;
  border-radius: 50%;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .15), 0 0 0 1px rgba(47, 52, 61, .2);
}

#simp .simp-footer {
  padding: 10px 10px 12px;
  font-size: 90%;
  text-align: center;
  opacity: .7;
}

#simp .simp-display {
  overflow: hidden;
  max-height: 650px;
  transition: max-height .5s ease-in-out;
}

#simp .simp-hide {
  max-height: 0;
}

/* playlist */
#simp ul {
  margin: 0px 0 0;
  padding: 0;
  list-style: none;
  max-height: 245px;
}

#simp ul li {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  margin: 0;
  padding: 8px 20px;
  cursor: pointer;
}

#simp ul li:last-child {
  padding-bottom: 13px;
}

#simp ul li:nth-child(odd) {
  background: #0e1621;
}

#simp ul li:hover {
  background: #242f3d;
}

#simp ul li.simp-active {
  background: #4082bc;
  color: #fff;
}

#simp ul li .simp-desc {
  font-size: 90%;
  opacity: .5;
  margin-left: 5px;
}

/* playlist scrollbar */
#simp ul {
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-color: #73797f #2f3841;
}

#simp ul::-webkit-scrollbar-track {
  background-color: #2f3841;
}

#simp ul::-webkit-scrollbar {
  width: 6px;
  background-color: #2f3841;
}

#simp ul::-webkit-scrollbar-thumb {
  background-color: #73797f;
}

/* progress animation */
@-webkit-keyframes audio-progress {
  to {
    background-position: 25px 0;
  }
}

@keyframes audio-progress {
  to {
    background-position: 25px 0;
  }
}

.effect-wave {
  width: 36px;
  height: 42px;
  object-fit: contain;
  background-repeat: no-repeat;
}
</style>
